<div class="payment-result">
    <ng-container *ngIf="view === 'pending'">
        <div class="icon pending" aria-hidden="true">⏳</div>
        <h2>{{ 'common.PAYMENT.PENDING_TITLE' | translate }}</h2>

        <p>
            <b>{{ 'common.PAYMENT.ORDER_CODE' | translate }}:</b>
            {{ orderCode }}
        </p>
        <p>{{ 'common.PAYMENT.PENDING_MESSAGE' | translate }}</p>

        <p *ngIf="timedOut" class="timeout-note">
            {{ 'common.PAYMENT.PENDING_TIMEOUT' | translate }}
        </p>

        <p class="recheck-hint">{{ 'common.PAYMENT.PENDING_RECHECK_HINT' | translate }}</p>
        <p *ngIf="recheckMessageKey" class="timeout-note">{{ recheckMessageKey | translate }}</p>

        <div class="actions">
            <button (click)="recheckWithGateway()" class="secondary" [disabled]="rechecking">
                {{ 'common.PAYMENT.PENDING_RECHECK' | translate }}
            </button>
            <button (click)="goToOrders()" class="primary">
                {{ 'common.PAYMENT.VIEW_ORDERS' | translate }}
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="view === 'success'">
        <div class="icon success" aria-hidden="true">✔</div>
        <h2>{{ 'common.PAYMENT.SUCCESS_TITLE' | translate }}</h2>

        <p>
            <b>{{ 'common.PAYMENT.ORDER_CODE' | translate }}:</b> 
            {{ orderCode }}
        </p>
        <p>
            <b>{{ 'common.PAYMENT.TRANSACTION_ID' | translate }}:</b> 
            {{ transactionId }}
        </p>

        <button (click)="goHome()" class="primary">
            {{ 'common.PAYMENT.BACK_TO_HOME' | translate }}
        </button>
    </ng-container>

    <ng-container *ngIf="view === 'review'">
        <div class="icon pending" aria-hidden="true">⏳</div>
        <h2>{{ 'common.PAYMENT.REVIEW_TITLE' | translate }}</h2>

        <p>
            <b>{{ 'common.PAYMENT.ORDER_CODE' | translate }}:</b>
            {{ orderCode }}
        </p>
        <p *ngIf="transactionId">
            <b>{{ 'common.PAYMENT.TRANSACTION_ID' | translate }}:</b>
            {{ transactionId }}
        </p>
        <p>{{ message || ('common.PAYMENT.REVIEW_MESSAGE' | translate) }}</p>

        <button (click)="goToOrders()" class="primary">
            {{ 'common.PAYMENT.VIEW_ORDERS' | translate }}
        </button>
    </ng-container>

    <ng-container *ngIf="view === 'failed'">
        <div class="icon failed" aria-hidden="true">✖</div>
        <h2>{{ 'common.PAYMENT.FAILED_TITLE' | translate }}</h2>

        <p>
            <b>{{ 'common.PAYMENT.ORDER_CODE' | translate }}:</b>
            {{ orderCode }}
        </p>
        <p>
            <b>{{ 'common.PAYMENT.REASON' | translate }}:</b>
            {{ message }}
        </p>

        <button *ngIf="canRetry" (click)="retryPayment()" class="danger" [disabled]="retrying">
            {{ 'common.PAYMENT.RETRY' | translate }}
        </button>

        <button *ngIf="!canRetry" (click)="goHome()" class="primary">
            {{ 'common.PAYMENT.BACK_TO_HOME' | translate }}
        </button>
    </ng-container>
</div>
